import { useState } from 'react';

function getSidebarState(): boolean {
  const stored = localStorage.getItem('sidebar.collapsed');
  return stored ? stored === '1' : false;
}

export function useSidebar() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(getSidebarState);

  const toggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('sidebar.collapsed', newState ? '1' : '0');
  };

  return { sidebarCollapsed, toggleSidebar };
}
